export default {
  login: "/auth/login",
  getDataByCodeLanguage: "/params/getDataByCodeLanguage",

  getDataByDomainLanguage: "/params/getDataByDomainLanguage",
  getInitialConf: "/auth/getInitialConf",
  getFiles: "/files/getfilesS3",
  createFileFolder: "/files/create-folderS3",
  uploadFile: process.env.REACT_APP_CLOUD_FILES ==="YES"? "/files/uploadS3":"/files/upload",
  deleteFile: process.env.REACT_APP_CLOUD_FILES ==="YES"? "/files/deleteS3":"/files/delete",

  
  getResumeTasksByUser: "users/get-resume-tasks",
  getResumeTasksByUserV2: "users/get-resume-tasks-v2",
  getActiveTasksByUser: "engine-users/get-active-tasks",
  getActiveTasksByVar: "engine-users/get-active-tasks-by-var",
  getTaskDetails: "/engine-users/get-task-details",
  executeTask: "engine-users/execute-task",
  getHistoryFlows: "/engine-users/get-history-flows",
  getFlowInstanceVars: "/engine-users/get-flow-instance-vars",
  getFlowFullVars: "/engine-users/get-flow-full-vars",
  getErrorTasksSummary: "/engine-users/get-error-tasks-summary",
  getHistoryJobs: "/engine-users/get-history-jobs",
  getHistoryFlow: "/engine-users/get-history-flow",
  changeTasks: "/engine-users/change-tasks",
  reactivateTask: "/engine-users/reactivate-task",
  getReassignCandidates: "/engine-users/get-reassign-candidates",
  reassignTask: "/engine-users/reassign-task",
  suspendTask: "/engine-users/suspend-task",
  resumeTask: "/engine-users/resume-task",
  killTask: "/engine-users/kill-task",
  countActiveTasks: "/engine-users/count-tasks",
  saveCommentary: "/engine-users/save-commentary",

  RecoveryPass: "/public/users/recover-password",
  ResetPassword: "/public/users/reset-password",
  getTemplateForm: "/forms/get-single-by-code",
  updateDiagramFlow: "/flows/update-diagram",

  getFlows: "/flows/get-all",
  getFlowById: "/flows/get-single",
  getActors: "/actors/get-all",
  getTasks: "/tasks/get-all",
  getFlowVars: "/flows/get-flow-vars",
  initFlow: "/flows/init-flow",

  getOrganizations: "/organizations/get-all",
  setOrganizations: "/organizations/create",
  updateOrganizations: "/organizations/update",
  deleteOrganizations: "/organizations/delete",
  updateParentOrganizations: "/organizations/update-parent",
  getActors: "/actors/get-all",
  getActorsAndOrgs: "/actors/getActorsAndOrgs",
  setActors: "/actors/create",
  updateActors: "/actors/update",
  deleteActors: "/actors/delete",
  updateParentActors: "/actors/update-parent",

  saveTemplate: "/components/create",
  getComponentById: "/components/get-single",
  getPrivateTemplates: "/components/get-templates",

  getComponentReport: "/components/get-component-report",

  initSocket: "/engine-users/init-listener",
  updatePassword: "/users/update-password",
  adminResetPassword: "/users/admin-reset-password",
  getUserSingle: "/users/get-single",
  getActorsByUser: "/actors/get-actors-by-userid",
  getOfficesByUser: "/offices/get-offices-by-userid",

  getRoles: "/usergroups/get-all",
  saveFlowField: "/engine-users/save-flow-field",
  testApi: "/engine-users/test-api",

  bulkData: "/files/bulk-data",
  getBulkData: "/files/get-bulk-data",

  // ── Métricas BPM ──
  bpmOverview:    "/engine-users/metrics/overview",
  bpmBacklog:     "/engine-users/metrics/task-backlog",
  bpmFlowCycle:   "/engine-users/metrics/flow-cycle",
  bpmThroughput:  "/engine-users/metrics/throughput",
  bpmBottlenecks: "/engine-users/metrics/bottlenecks",
  bpmWorkload:    "/engine-users/metrics/workload",
  bpmTransitions: "/engine-users/metrics/transitions",
  bpmVariables:   "/engine-users/metrics/variables",
};
